export { default as MultipleInsurancesFirstStep } from "./multipleInsurancesFirstStep";
export { default as MultipleInsurancesSecondStep } from "./multipleInsurancesSecondStep";
